import React from 'react';

const RegisteredBadge = () => {
  return (
    <div className="non-registered-badge mt-1">
      <p>Registered User</p>
    </div>
  );
};

export default RegisteredBadge;
